// extracted by mini-css-extract-plugin
export var readonly = "_fw-1";
export var star = "_fw-0";